import React, { useState } from 'react';
import { Grid } from '@mui/material';
import HospitalProceduresList from './list/HospitalProceduresList';
import HospitalProcedureForm from './form/HospitalProcedureForm';
import ConfirmDialog from 'components/confirm-dialog/ConfirmDialog';
import { countLabel, RecordToolbar } from 'components/record-shell/RecordList';
import { Hospital, HospitalProcedure } from 'types/hospital';

interface HospitalProceduresProps {
  hospital: Hospital;
  handleChangeAddProcedure(procedure: HospitalProcedure): void;
  handleDeleteProcedure(procedure: HospitalProcedure): void;
}

const HospitalProcedures: React.FC<HospitalProceduresProps> = ({
  hospital,
  handleDeleteProcedure,
  handleChangeAddProcedure,
}) => {
  const [addDialogOpen, setAddDialogOpen] = useState(false);
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState<HospitalProcedure | null>(null);
  const [procedureInfo, setProcedureInfo] = useState<HospitalProcedure>({
    sale_price_max: 0,
    sale_price_min: 0,
    id: 0,
    hospital_id: 0,
    procedure: null,
    procedure_id: 0,
  });

  function handleChangeProcedureInfo(index: keyof HospitalProcedure, value: any) {
    setProcedureInfo(prev => ({ ...prev, [index]: value }));
  }

  function handleAddProcedure(procedureInfo: HospitalProcedure | null) {
    if (!procedureInfo) return;
    handleChangeAddProcedure(procedureInfo);
    setAddDialogOpen(false);
    setProcedureInfo({
      sale_price_max: 0,
      sale_price_min: 0,
      procedure: null,
      id: 0,
      procedure_id: 0,
      hospital_id: 0,
    });
  }

  function onExited() {
    setAddDialogOpen(false);
    setProcedureInfo({
      sale_price_max: 0,
      sale_price_min: 0,
      procedure: null,
      id: 0,
      procedure_id: 0,
      hospital_id: 0,
    });
    setEditDialogOpen(false);
  }

  function handleEditProcedure(hospital: HospitalProcedure, index: number) {
    setEditDialogOpen(true);
    setProcedureInfo(hospital);
  }

  return (
    <Grid container size={12} spacing={2}>
      {confirmDialogOpen && (
        <ConfirmDialog
          confirmLabel="Excluir"
          destructive
          handleNoClick={() => setConfirmDialogOpen(null)}
          handleYesClick={() => {
            handleDeleteProcedure(confirmDialogOpen);
            setConfirmDialogOpen(null);
          }}
          title="Tem certeza que deseja excluir este procedimento?"
        />
      )}
      <Grid size={12}>
        <RecordToolbar
          title={countLabel(hospital.procedures.length, 'procedimento', 'procedimentos', 'Nenhum procedimento')}
          addLabel="Adicionar procedimento"
          onAdd={() => setAddDialogOpen(true)}
        />
      </Grid>

      {hospital.procedures.length > 0 && (
        <Grid size={12}>
          <HospitalProceduresList
            procedures={hospital.procedures}
            handleDeleteProcedure={item => setConfirmDialogOpen(item)}
            handleEditProcedure={handleEditProcedure}
          />
        </Grid>
      )}

      {addDialogOpen && (
        <HospitalProcedureForm
          type="new"
          handleChangeProcedureInfo={handleChangeProcedureInfo}
          procedureInfo={procedureInfo}
          handleAddProcedure={handleAddProcedure}
          onExited={onExited}
        />
      )}

      {/* Formulário de Edição de Produto */}
      {!!procedureInfo.id && editDialogOpen && (
        <HospitalProcedureForm
          type="edit"
          handleChangeProcedureInfo={handleChangeProcedureInfo}
          procedureInfo={procedureInfo}
          handleAddProcedure={handleAddProcedure}
          onExited={onExited}
        />
      )}
    </Grid>
  );
};

export default HospitalProcedures;
